const GL_QUERY_RESULT_EXT = 0x8866;
const GL_QUERY_RESULT_AVAILABLE_EXT = 0x8867;
const GL_TIME_ELAPSED_EXT = 0x88bf;

export default function timer(gl, extensions) {
  if (!extensions.ext_disjoint_timer_query) {
    return null;
  }

  // QUERY POOL BEGIN
  const queryPool = [];
  function allocQuery() {
    return (
      queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT()
    );
  }
  function freeQuery(query) {
    queryPool.push(query);
  }
  // QUERY POOL END

  const pendingQueries = [];
  function beginQuery(stats) {
    const query = allocQuery();
    extensions.ext_disjoint_timer_query.beginQueryEXT(
      GL_TIME_ELAPSED_EXT,
      query
    );
    pendingQueries.push(query);
    pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats);
  }

  function endQuery() {
    extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
  }

  //
  // Pending stats pool.
  //
  function PendingStats() {
    this.startQueryIndex = -1;
    this.endQueryIndex = -1;
    this.sum = 0;
    this.stats = null;
  }
  const pendingStatsPool = [];
  function allocPendingStats() {
    return pendingStatsPool.pop() || new PendingStats();
  }
  function freePendingStats(pendingStats) {
    pendingStatsPool.push(pendingStats);
  }
  // Pending stats pool end

  const pendingStats = [];
  function pushScopeStats(start, end, stats) {
    const ps = allocPendingStats();
    ps.startQueryIndex = start;
    ps.endQueryIndex = end;
    ps.sum = 0;
    ps.stats = stats;
    pendingStats.push(ps);
  }

  // we should call this at the beginning of the frame,
  // in order to update gpuTime
  const timeSum = [];
  const queryPtr = [];
  function update() {
    let ptr, i;

    const n = pendingQueries.length;
    if (n === 0) {
      return;
    }

    // Reserve space
    queryPtr.length = Math.max(queryPtr.length, n + 1);
    timeSum.length = Math.max(timeSum.length, n + 1);
    timeSum[0] = 0;
    queryPtr[0] = 0;

    // Update all pending timer queries
    let queryTime = 0;
    ptr = 0;
    for (i = 0; i < pendingQueries.length; ++i) {
      const query = pendingQueries[i];
      if (
        extensions.ext_disjoint_timer_query.getQueryObjectEXT(
          query,
          GL_QUERY_RESULT_AVAILABLE_EXT
        )
      ) {
        queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(
          query,
          GL_QUERY_RESULT_EXT
        );
        freeQuery(query);
      } else {
        pendingQueries[ptr++] = query;
      }
      timeSum[i + 1] = queryTime;
      queryPtr[i + 1] = ptr;
    }
    pendingQueries.length = ptr;

    // Update all pending stat queries
    ptr = 0;
    for (i = 0; i < pendingStats.length; ++i) {
      const stats = pendingStats[i];
      const start = stats.startQueryIndex;
      const end = stats.endQueryIndex;
      stats.sum += timeSum[end] - timeSum[start];
      const startPtr = queryPtr[start];
      const endPtr = queryPtr[end];
      if (endPtr === startPtr) {
        stats.stats.gpuTime += stats.sum / 1e6;
        freePendingStats(stats);
      } else {
        stats.startQueryIndex = startPtr;
        stats.endQueryIndex = endPtr;
        pendingStats[ptr++] = stats;
      }
    }
    pendingStats.length = ptr;
  }

  return {
    beginQuery: beginQuery,
    endQuery: endQuery,
    pushScopeStats: pushScopeStats,
    update: update,
    getNumPendingQueries: function() {
      return pendingQueries.length;
    },
    clear: function() {
      queryPool.push.apply(queryPool, pendingQueries);
      for (let i = 0; i < queryPool.length; i++) {
        extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i]);
      }
      pendingQueries.length = 0;
      queryPool.length = 0;
    },
    restore: function() {
      pendingQueries.length = 0;
      queryPool.length = 0;
    },
  };
}
